export const divideSteps = steps => {
  return {
    defaultSteps: steps.filter(step => step.default),
    customSteps: steps.filter(step => !step.default),
  }
}